<script setup lang="ts">
import type {PainPointsBlock} from '~/types/legacy'
import type {Populated} from '~/types/populated'

const props = defineProps<{
  data: Populated<PainPointsBlock>
}>()
</script>

<template>
  <div class="mt-24">
    <div class="mb-8 flex flex-col gap-6 md:flex-row md:gap-8">
      <div class="flex flex-col md:w-2/3">
        <Heading class="font-semibold mb-2 text-lg" as="h2" size="caption">
          {{ data.eyebrow }}
        </Heading>
        <Heading class="text-2xl" as="h3" size="medium">
          {{ $t('warehouse.pain_points.title') }}
        </Heading>
        <Heading class="mt-1 text-2xl text-main-600" as="h3" size="medium">
          {{ $t('warehouse.pain_points.sub_title') }}
        </Heading>
      </div>

      <Paragraph size="normal" weight="normal" as="p" class="md:w-8/12">
        {{ data.body }}
      </Paragraph>
    </div>

    <div class="grid grid-cols-1 gap-4 border-t py-12 md:grid-cols-2">
      <ul class="space-y-4">
        <li v-for="(issue, index) in data.issues?.slice(0, 3)" :key="index" class="flex items-center">
          <Icon class="h-6 w-6 flex-shrink-0 rounded-full bg-red-200 p-1 text-red-800" name="ic:baseline-minus" />
          <span class="ml-3">{{ issue.text }}</span>
        </li>
      </ul>

      <ul class="space-y-4">
        <li v-for="(issue, index) in data.issues?.slice(3, 6)" :key="index" class="flex items-center">
          <Icon class="h-6 w-6 flex-shrink-0 rounded-full bg-red-200 p-1 text-red-800" name="ic:baseline-minus" />
          <span class="ml-3">{{ issue.text }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
